import CarRightDrawerContainer from "../../../components/car/other/CarRightDrawer";

const CarRightDrawer = () => {
  return <CarRightDrawerContainer />;
};

export default CarRightDrawer;
